import React, { useState, useEffect } from 'react';
import './HeroCarousel.css';
import { useNavigate } from "react-router-dom";

const HeroCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);

   const navigate = useNavigate(); 

  // Sample images - înlocuiește cu imaginile tale
  const slides = [
    {
      id: 1,
      image: "https://images.pexels.com/photos/1827054/pexels-photo-1827054.jpeg",
      title: "Mobilă pe gustul tău",
      subtitle: "Modern",
      buttonText: "Afla mai multe",
      link: "/servicii-mobila-la-comanda-sector-2"
    },
    {
      id: 2,
      image: "https://images.pexels.com/photos/6508341/pexels-photo-6508341.jpeg",
      title: "Locuința ta, stilul tău", 
      subtitle: "Lifestyle",
      buttonText: "Exploreaza colectia",
      link: "/proiecte-mobila-sector-2-bucuresti"
    },
    {
      id: 3,
      image: "https://images.pexels.com/photos/7534280/pexels-photo-7534280.jpeg",
      title: "Mobila care dă viață casei tale",
      subtitle: "Comfortul intalneste stilul",
      buttonText: "Vezi mai multe",
      link: "/catalog-mobila-bucuresti"
    }
  ];

  // Auto-scroll functionality
  useEffect(() => {
    if (!isAutoPlaying) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); // 5 seconds

    return () => clearInterval(interval);
  }, [isAutoPlaying, slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
    setIsAutoPlaying(false);
    // Resume auto-play after 10 seconds
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    setIsAutoPlaying(false);
    // Resume auto-play after 10 seconds
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  const goToSlide = (index) => {
    setCurrentSlide(index);
    setIsAutoPlaying(false);
    setTimeout(() => setIsAutoPlaying(true), 10000);
  };

  return (
    <section className="hero-carousel">
      <div className="carousel-container">
        {/* Slides */}
        <div className="slides-wrapper">
          {slides.map((slide, index) => (
            <div
              key={slide.id}
              className={`slide ${index === currentSlide ? 'active' : ''}`}
              style={{
                backgroundImage: `url(${slide.image})`,
                transform: `translateX(${(index - currentSlide) * 100}%)`
              }}
            >
              <div className="slide-overlay"></div>
              <div className="slide-content">
                <h1 className="slide-title">{slide.title}</h1>
                <p className="slide-subtitle">{slide.subtitle}</p>
                 <button 
  className="slide-button"
  onClick={() => {
    console.log("Buton apăsat, merg spre:", slide.link);
    try {
      navigate(slide.link);
    } catch (error) {
      console.error("Eroare la navigare:", error);
    }
  }}
>
          {slide.buttonText}
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="m9 18 6-6-6-6"/>
          </svg>
        </button>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Arrows */}
        <button 
          className="carousel-arrow carousel-arrow-left" 
          onClick={prevSlide}
          aria-label="Previous slide"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="m15 18-6-6 6-6"/>
          </svg>
        </button>

        <button 
          className="carousel-arrow carousel-arrow-right" 
          onClick={nextSlide}
          aria-label="Next slide"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="m9 18 6-6-6-6"/>
          </svg>
        </button>

        {/* Dots Indicator */}
        <div className="carousel-dots">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`dot ${index === currentSlide ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>

        {/* Progress Bar */}
        <div className="carousel-progress">
          <div 
            className="progress-bar"
            style={{
              animationDuration: isAutoPlaying ? '5s' : '0s',
              animationPlayState: isAutoPlaying ? 'running' : 'paused'
            }}
            key={currentSlide} // Reset animation on slide change
          />
        </div>
      </div>
    </section>
  );
};

export default HeroCarousel;